import { render, staticRenderFns } from "./ErreurCollecte.vue?vue&type=template&id=4380ff84"
import script from "./ErreurCollecte.vue?vue&type=script&lang=js"
export * from "./ErreurCollecte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports